import './Navbar.css';

import React from 'react';

// Import icons
import {
  FaBars,
  FaSignOutAlt,
  FaUserCircle,
} from 'react-icons/fa';

const Navbar = ({ user, onSignOut }) => {
  // Handle logo error if image doesn't load
  const handleLogoError = (e) => {
    e.target.style.display = 'none';
    // Maybe show a placeholder or just the text
    const logoTextElement = e.target.parentElement.querySelector('.navbar-title');
    if (logoTextElement) {
      logoTextElement.style.marginLeft = '0';
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <img 
            src="/logo.png" 
            alt="Utility Audit Pro" 
            className="navbar-logo" 
            onError={handleLogoError}
          />
          <h1 className="navbar-title">Utility Audit Pro</h1>
          <button className="navbar-menu-toggle">
            <FaBars />
          </button>
        </div>
        
        {user && (
          <div className="navbar-user">
            <div className="user-info">
              <div className="user-avatar">
                {user.displayName ? (
                  <span>{user.displayName.charAt(0).toUpperCase()}</span>
                ) : (
                  <FaUserCircle />
                )}
              </div>
              <span className="user-name">{user.displayName || user.email || user.username}</span>
            </div>
            <button 
              className="sign-out-btn" 
              onClick={onSignOut}
              aria-label="Sign out"
            >
              <span className="sign-out-text">Sign Out</span>
              <FaSignOutAlt className="sign-out-icon" />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;